import type { QueryKey } from '@tanstack/react-query';
import { queryClient } from '../api';

export async function pollApiResult<Data>({
	queryKey,
	queryFn,
	pollingInterval,
	pollingLimit = 100,
}: {
	queryKey: QueryKey;
	queryFn: () => Promise<Data>;
	pollingInterval: (data: Data) => number | null;
	pollingLimit?: number;
}): Promise<Data> {
	return new Promise((resolve, reject) => {
		let pollingCount = 0;

		const poll = async () => {
			if (pollingLimit && pollingCount >= pollingLimit) {
				reject(new Error('Polling limit reached'));
				return;
			}
			pollingCount += 1;

			try {
				const data = await queryClient.fetchQuery({
					queryKey,
					queryFn: () => queryFn(),
					gcTime: 0,
					staleTime: 0,
				});
				const interval = pollingInterval(data);
				if (interval === null) {
					resolve(data);
				} else {
					setTimeout(poll, interval);
				}
			} catch (error) {
				reject(error);
			}
		};

		poll();
	});
}
